export default __webpack_public_path__ + "static/media/0.23b8b925.png";